import { computed, inject } from 'vue'
import { useStore } from 'vuex'
import { useLoading } from 'vue-loading-overlay'
import { useToast } from 'vue-toast-notification'
import { useRouter } from 'vue-router'
import { useMixpanel } from './mixpanel.js'
import useLogout from './useLogout.js'

export function useNavigationMenu() {
  const $store = useStore()
  const $router = useRouter()
  const mixpanel = useMixpanel()

  const $loading = useLoading({
    canCancel: false,
    isFullPage: true,
    color: '#a15cff',
  })

  const logoutRequest = useLogout()

  const user = computed(() => $store.state.user)

  function goHome(fromLogoMenu = false) {
    $router.push('/')
    $store.commit('SET_MOBILE_MENU_OPEN', {
      open: false,
    })
    return false
  }

  function goToGenerator() {
    $router.push('/nsfw-ai-image-generator')
    $store.commit('SET_MOBILE_MENU_OPEN', {
      open: false,
    })
    return false
  }

  function goToChat() {
    $store.commit('SET_MOBILE_MENU_OPEN', {
      open: false,
    })

    if (!user.value) {
      $store.commit('SET_LOGIN_REGISTER_POPUP_OPEN', {
        open: true,
      })

      return
    }

    $router.push('/chat')

    return false
  }

  function goToSaved() {
    $store.commit('SET_MOBILE_MENU_OPEN', {
      open: false,
    })

    if (!user.value) {
      $store.commit('SET_LOGIN_REGISTER_POPUP_OPEN', {
        open: true,
      })

      return
    }

    $router.push('/saved')

    return false
  }

  function goToVideos() {
    $store.commit('SET_MOBILE_MENU_OPEN', {
      open: false,
    })

    if (!user.value) {
      $store.commit('SET_LOGIN_REGISTER_POPUP_OPEN', {
        open: true,
      })

      return
    }

    $router.push('/videos')

    return false
  }

  function goToSettings() {
    $store.commit('SET_MOBILE_MENU_OPEN', {
      open: false,
    })

    if (!user.value) {
      $store.commit('SET_LOGIN_REGISTER_POPUP_OPEN', {
        open: true,
      })

      return
    }

    $router.push('/settings')

    return false
  }

  function goToAffiliate() {
    $router.push('/affiliate')

    return false
  }

  async function logout() {
    const loader = $loading.show()

    $store.commit('SET_DISCOUNT_POPUP', {
      open: false,
    })

    $store.commit('SET_FREE_RATING', {})

    await logoutRequest().catch((e) => {
      loader.hide()
      throw e
    })

    loader.hide()

    await $router.push('/')
    $store.commit('SET_MOBILE_MENU_OPEN', {
      open: false,
    })
    $store.commit('SET_USER', null)
  }

  return {
    goHome,
    goToGenerator,
    goToChat,
    goToSaved,
    goToVideos,
    goToSettings,
    goToAffiliate,
    logout,
  }
}
